import { useState } from "react";

const testimonials = [
  {
    name: "Camille R.",
    age: "42, Interior Designer",
    avatar: "https://public.readdy.ai/ai/img_res/63dca3f50202d78fa07a1236facc25a1.jpg",
    stars: 5,
    text: "Isabelle completely transformed my hair. I walked in with damaged, over-processed color and left with the most gorgeous honey balayage I've ever had. The European techniques they use are on another level — nothing in Vegas compares.",
    service: "Balayage",
  },
  {
    name: "Sandra M.",
    age: "38, Marketing Executive",
    avatar: "https://readdy.ai/api/search-image?query=attractive%20confident%20professional%20woman%2038%20years%20old%20headshot%20portrait%20light%20background%20warm%20smile%2C%20polished%20look%2C%20business%20professional&width=120&height=120&seq=test2&orientation=squarish",
    stars: 5,
    text: "I've been going to VegasGlamHair for two years now and I wouldn't trust anyone else with my hair. Margot is an absolute genius with color — my platinum blonde has never looked so healthy and vivid.",
    service: "Full Color",
  },
  {
    name: "Diana L.",
    age: "45, Real Estate Agent",
    avatar: "https://readdy.ai/api/search-image?query=beautiful%20woman%2045%20years%20old%20headshot%20professional%20portrait%20neutral%20cream%20background%20confident%20warm%20expression&width=120&height=120&seq=test3&orientation=squarish",
    stars: 5,
    text: "Sofia did my hair for my daughter's wedding and every single photo is breathtaking. She listened to exactly what I wanted, offered brilliant suggestions, and delivered perfection. Highly recommend for any special event.",
    service: "Bridal Updo",
  },
  {
    name: "Victoria P.",
    age: "33, Hospitality Manager",
    avatar: "https://readdy.ai/api/search-image?query=stylish%20woman%2033%20years%20old%20headshot%20portrait%20warm%20background%20genuine%20smile%20elegant%20professional&width=120&height=120&seq=test4&orientation=squarish",
    stars: 5,
    text: "First-time client here — used the 20% off promo and I am now a customer for life. Elena gave me the most precise lob cut I've ever had. The salon itself feels like a luxury spa. Worth every penny.",
    service: "Precision Cut",
  },
  {
    name: "Rachel T.",
    age: "49, Attorney",
    avatar: "https://readdy.ai/api/search-image?query=sophisticated%20woman%2049%20years%20old%20professional%20headshot%20portrait%20light%20neutral%20background%20polished%20elegant%20expression&width=120&height=120&seq=test5&orientation=squarish",
    stars: 5,
    text: "After years of going to different salons around Vegas, I finally found my home. The team here truly understands quality. My keratin treatment lasted months longer than anywhere else.",
    service: "Keratin Treatment",
  },
];

export default function ClientTestimonials() {
  const [current, setCurrent] = useState(0);
  const visible = 3;
  const max = testimonials.length - visible;

  const prev = () => setCurrent((c) => Math.max(0, c - 1));
  const next = () => setCurrent((c) => Math.min(max, c + 1));

  return (
    <section className="w-full bg-[#faf8f5] py-24 px-6" id="testimonials">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-[#C9A96E] text-xs font-semibold tracking-[0.3em] uppercase mb-3 block">Client Love</span>
          <h2 className="text-neutral-900 text-3xl md:text-5xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>
            What Our Clients Say
          </h2>
          <div className="flex items-center justify-center gap-2 mt-4">
            <div className="flex gap-1">
              {[1,2,3,4,5].map(i => <i key={i} className="ri-star-fill text-[#C9A96E] text-sm"></i>)}
            </div>
            <span className="text-neutral-500 text-sm">5.0 · 400+ Google Reviews</span>
          </div>
        </div>

        <div className="relative overflow-hidden">
          <div
            className="flex gap-6 transition-transform duration-500"
            style={{ transform: `translateX(calc(-${current * (100 / visible)}% - ${current * 24 / visible}px))` }}
          >
            {testimonials.map((t) => (
              <div
                key={t.name}
                className="min-w-[calc(33.333%-16px)] bg-white rounded-lg p-8 border border-neutral-100 flex flex-col"
              >
                <div className="flex gap-1 mb-5">
                  {[1,2,3,4,5].map(i => <i key={i} className="ri-star-fill text-[#C9A96E] text-sm"></i>)}
                </div>
                <p className="text-neutral-600 text-sm leading-relaxed mb-6 flex-1 italic">&ldquo;{t.text}&rdquo;</p>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full overflow-hidden shrink-0">
                    <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div>
                    <p className="text-neutral-900 text-sm font-semibold">{t.name}</p>
                    <p className="text-neutral-400 text-xs">{t.age}</p>
                    <span className="text-[#C9A96E] text-xs font-medium">{t.service}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex justify-center gap-4 mt-10">
          <button onClick={prev} disabled={current === 0} className="w-10 h-10 flex items-center justify-center rounded-full border border-neutral-200 hover:border-[#C9A96E] hover:text-[#C9A96E] transition-colors cursor-pointer disabled:opacity-30">
            <i className="ri-arrow-left-s-line"></i>
          </button>
          <button onClick={next} disabled={current >= max} className="w-10 h-10 flex items-center justify-center rounded-full border border-neutral-200 hover:border-[#C9A96E] hover:text-[#C9A96E] transition-colors cursor-pointer disabled:opacity-30">
            <i className="ri-arrow-right-s-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
